import { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { tenantLogoUrl } from "@/lib/api";

export function TenantBrand({ user, size = "md", className = "" }) {
  const [logoFailed, setLogoFailed] = useState(false);
  const h = size === "sm" ? "h-10" : "h-16";
  const maxW = size === "sm" ? "max-w-[90px]" : "max-w-[120px]";

  useEffect(() => {
    setLogoFailed(false);
  }, [user?.tenant_id, user?.tenant_has_logo]);

  const showLogo = user?.tenant_has_logo && !logoFailed;
  const companyName = user?.tenant_name || "Empresa";

  return (
    <div className={`flex items-center gap-3 min-w-0 ${className}`}>
      {showLogo ? (
        <img
          src={tenantLogoUrl(user?.tenant_id)}
          alt={companyName}
          className={`${h} ${maxW} object-contain shrink-0`}
          onError={() => setLogoFailed(true)}
        />
      ) : (
        <div className={`${h} aspect-square rounded-lg bg-slate-800/80 border border-slate-700 flex items-center justify-center shrink-0`}>
          <Building2 className={size === "sm" ? "h-5 w-5 text-sky-400" : "h-7 w-7 text-sky-400"} />
        </div>
      )}
      <div className="min-w-0">
        <div className="font-display font-bold text-slate-50 text-lg leading-tight truncate">{companyName}</div>
        <div className="text-[10px] uppercase tracking-[0.16em] text-slate-500 font-mono">Almoxarifado</div>
      </div>
    </div>
  );
}
